import { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  className?: string;
  unstyled?: boolean;
}

export const Link = memo(({ unstyled = false, children, className, ...props }: LinkProps) => {
  return (
    <a
      className={
        unstyled ? '' : classNames('text-bolt-elements-link hover:text-bolt-elements-linkHover underline', className)
      }
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  );
});
